import {Injectable} from '@angular/core';
import {Principal} from 'app/core/auth/principal.service';
import {AuthServerProvider} from 'app/core/auth/auth-jwt.service';
import {Store} from '@ngxs/store';
import {LogoutUser} from 'app/blocks/store/actions/logout-reducer';
import {TranslateService} from '@ngx-translate/core';
import {SuperUserService} from 'app/core/auth/super-user.service';

@Injectable()
export class LoginService {
    constructor(
        // private languageService: JhiLanguageService,
        private principal: Principal,
        private authServerProvider: AuthServerProvider,
        private _superUserService: SuperUserService,
        private _store: Store,
        private _translateService: TranslateService
    ) {}

    login(credentials, callback?): Promise<any> {
        const cb = callback || (() => {});

        return new Promise((resolve, reject) => {
            this.authServerProvider.login(credentials).subscribe(
                (data) => {
                    this.principal.identity(true).then((account) => {
                        // After the login the language will be changed to
                        // the language selected by the user during his registration
                        if (account !== null) {
                            this._translateService.use(account.langKey);
                        }
                        resolve(data);
                    });
                    return cb();
                },
                (err) => {
                    this.logout();
                    reject(err);
                    return cb(err);
                }
            );
        });
    }

    createAccount(credentials, callback?): Promise<any> {
        return this.authServerProvider.create(credentials).toPromise();
    }

    loginWithToken(jwt, rememberMe): Promise<any> {
        return this.authServerProvider.loginWithToken(jwt, rememberMe);
    }

    logout(reload = false): void {
        this.authServerProvider.logout().subscribe();
        this.principal.authenticate(null);
        this._store.dispatch(new LogoutUser());
        this._superUserService.setIsSuperUser(false);
        this._superUserService.setDifferentUser(null);
        if (reload) {
            window.location.href = '/login';
        }
    }

    clearAllTokens() {
        this.authServerProvider.clearAllTokens();
    }
}
